module.exports = __webpack_public_path__ + "img/16d013-40.2f7186e6.jpg";